import React from "react";

const alhad_deodhar = () => {
  return (
    <div>
      <h1>Alhad Deodhar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The company offered multiple roles across different domains - Analog,
        Digital, Embedded Software, and Sales, considering the various streams
        such as Computer, ENTC, and Electrical Engineering.
        <br />
        Computer Science students were primarily eligible for the Embedded
        Software role. Technically, they could also apply for the Sales role;
        however, the questions in that test were more aligned with the
        Electronics and Electrical domains.
        <br />
        Students eligible for the test were first shortlisted on the basis of a
        CGPA criteria and then further shortlisting was based on an Aptitude
        Test conducted on the HirePro platform. Candidates who cleared this
        round then had the interview round.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There was an Online Pre-Placement Talk first and then:
        <br />
        11 October - Aptitude Test (90 mins)
        <br />
        15 October - Interview Round
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Round consisted of a total of 41 questions, divided into
        three sections:
      </p>

      <p>
        <strong>(i) 20 questions</strong> - <em>General Logical Reasoning</em> -{" "}
        <strong>30 minutes</strong>
      </p>

      <p>
        <strong>(ii) 20 questions</strong> - <em>Programming Concepts</em> -{" "}
        <strong>40 minutes</strong>
        <br />
        These questions (C language or pseudocode) involved predicting the
        output of given code snippets, completing incomplete code, or general
        concept-based and fact-based questions.
      </p>

      <p>
        <strong>(ii) 1 Coding Question</strong> - <strong>20 minutes</strong>
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />8 students for the Analog role, 8 students for the Digital role, 7
        students for the Embedded role
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was released 2 days before the interviews. The things I
        revised were Operating Systems, C language concepts, especially related
        to bit-manipulations, projects mentioned in the resume. Additionally a
        Job Description Document and a Preparation Document were circulated; I
        made sure to go through it. I believe one should focus only on revision
        in that phase instead of trying to learn new topics, since with such
        limited time, you’d only understand it at a surface level, and that time
        is better spent strengthening familiar concepts; in my opinion its
        better to have more in depth knowledge about limited topics than
        superficial knowledge about many of them.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There was only 1 interview round; i.e., just a technical questions
        round.
        <br />
        I was first asked to introduce myself and then cover the projects I had
        mentioned. I made sure to explain the basic idea and concepts driving
        the project. Additionally, questions were asked about the subjects
        mentioned in the resume.
        <br />
        After that, I was asked to write code snippets for problems related to
        data structures and then asked about how I could optimize and improve
        each code, both in terms of time and space complexity. We had to write
        the code in C language and had to take care of syntax too since the
        editor did not have support for the same.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Operating Systems, Data structures, C Language and also Assembly, Theory
        of Computation (I had mentioned that in my resume)
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Notes of my own for the subjects covered in class and GeeksForGeeks
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Keep practicing regularly and understand new problem-solving approaches.
        During the test, if you have an idea but run short on time, write your
        thought process or partial logic in comments - while there’s no
        guarantee it will fetch marks, it still demonstrates your reasoning and
        approach, which is always worth a try.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />A few questions were asked about Projects but nothing about Clubs
        and Extracurricular Activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Be absolutely confident about everything you mention in your resume.
        Don’t include projects or subjects just for the sake of it; make sure
        you have a complete understanding of whatever you list. If you’re unsure
        about something, it’s easy for the interviewer to notice, which can
        leave a negative impression. Also, if you don’t know something, it’s
        best to say so honestly instead of trying to sound confident and risking
        an incorrect response.
      </p>

      <p>
        Be comfortable coding in C, especially with Data Structures and Bit
        Manipulation problems, as these areas are commonly tested.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Relax, Keep calm, You will do great : )
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong> <a href="mailto:deodhar.alhad@gmail.com">deodhar.alhad@gmail.com</a>
      </p>
    </div>
  );
};

export default alhad_deodhar;
